const initState = {
  locations: [],
  searched: [],
  location: {},
  toast: null,
  isProcessing: false,
  isLoaded: false,
};

export const locationReducer = (state = initState, action) => {
  switch (action.type) {
  case 'RESET_LOCATION_STATE':
    return { 
      ...initState
    };
  case 'RESET_TOAST_STATE':
    return {
      ...state,
      toast: null, 
      isProcessing: false,
    };

  case 'PROCESSING_LOCATION':
    return {
      ...state,
      toast: { type: 'LOADING', message: 'Please wait ...'},
      isProcessing: true,
    };

  case 'FETCH_LOCATIONS':
    return {
      ...state,
      locations: action.payload,
      toast: {type: 'SUCCESS'},
      isProcessing: false,
      isLoaded: true, // This is to make sure we avoid additional fetch calls.
    };
  case 'ADD_LOCATION':
    return {
      ...state,      
      locations: [...state.locations, action.payload],
      toast: { type: 'SUCCESS', message: 'Location saved successfully.'},
      isProcessing: false,
    };    
  case 'UPDATE_LOCATION':
    return {
      ...state,      
      locations: state.locations.map(location => location.id === action.payload.id ? {...action.payload } : { ...location }), //this works for update, but new item does not show up.
      // locations: [...state.locations.filter(item => item.id !== action.payload.id), Object.assign({}, action.payload)], #filter send the item to end of list when updated.
      searched: state.searched.map(location => location.id === action.payload.id ? {...action.payload } : { ...location }),
      toast: { type: 'SUCCESS', message: 'Location updated successfully.' },
      isProcessing: false,
    };
  case 'SEARCH_LOCATIONS':
    return {
      ...state,
      searched: action.payload,
      toast: {type: 'SUCCESS'},
      isProcessing: false,      
    };      
  case 'LOCATION_ERROR':
    return {
      ...state,
      isProcessing: false,
      toast: { type: 'ERROR', message: action.payload},
    };
  default:
    return state;
  }
};
